let activeLoad;
/**
 * Shares one in-flight full-graph request between active Explorer consumers.
 * The underlying request is aborted as soon as its final consumer leaves.
 */
export function loadGraphOnce(authToken, loader, signal) {
    if (signal.aborted) {
        return Promise.reject(signal.reason ?? new DOMException("Aborted", "AbortError"));
    }
    if (activeLoad?.authToken !== authToken) {
        activeLoad?.controller.abort();
        const controller = new AbortController();
        const promise = loader(authToken, controller.signal);
        activeLoad = { authToken, promise, controller, consumers: new Set() };
        const clearIfCurrent = () => {
            if (activeLoad?.promise === promise) {
                activeLoad = undefined;
            }
        };
        void promise.then(clearIfCurrent, clearIfCurrent);
    }
    const load = activeLoad;
    load.consumers.add(signal);
    const release = () => {
        signal.removeEventListener("abort", release);
        load.consumers.delete(signal);
        if (load.consumers.size === 0 && activeLoad === load) {
            activeLoad = undefined;
            load.controller.abort();
        }
    };
    signal.addEventListener("abort", release, { once: true });
    void load.promise.then(release, release);
    return load.promise;
}
export function resetGraphLoadCoordinatorForTests() {
    activeLoad?.controller.abort();
    activeLoad = undefined;
}
